/** Quizlet phrase-export client + pure helpers.
 *
 *  Phrases are generated mandatorily as part of the article pipeline and
 *  cached in S3. The reader fetches the cached bundle via GET and formats
 *  it as TSV for the clipboard. No on-demand generation, no cost dialog,
 *  no state machine — the server side does all the work upfront.
 */
import { apiClient } from '../../utils/api-client';

export interface Phrase {
  src: string;
  tgt: string;
  chunkId: number;
  sentenceIdx: number;
}

export interface PhraseBundle {
  articleId: string;
  sourceLanguage: string;
  targetLanguage: string;
  phrases: Phrase[];
  createdAt: string;
}

export async function apiGetPhrases(articleId: string): Promise<PhraseBundle> {
  return apiClient.get<PhraseBundle>(`/reader/articles/${encodeURIComponent(articleId)}/phrases`);
}

export function formatPhrasesAsTsv(phrases: Phrase[]): string {
  return phrases.map(p => `${p.src}\t${p.tgt}`).join('\n');
}
